<template>
  <v-card class="elevation-0">
    <v-data-table
      :headers="headers"
      :items="businessRules"
      :item-key="businessRules.index"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="totalRecords"
      @update:pagination="paginationUpdated"
      hide-details
      class="striped-table no-pagination-btn"
    >
      <template slot="items" slot-scope="props">
        <tr
          :key="props.index"
          :class="categoryClass(props.item.CategoryName)"
          :style="{
                        backgroundColor: (props.item.RuleKey == selectedRow ? '#C6EFCE' : '' ), 
                        color: (props.item.RuleKey == selectedRow ? '#00612e' : 'black' ),
                      }"
        >
          <td class="text-xs-left px-0">{{ props.item["RuleKey"] }}</td>
          <td class="text-xs-left px-0">{{ props.item["Description"] }}</td>
          <td class="text-xs-left px-0">{{ props.item["Value"] }}</td>
         
          <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
            <a
              class="ml-0 align-center"
              style="text-decoration: none"
              @click="openEditBusinessRules(props.item)"
            >EDIT</a>
          </td>
        </tr>
      </template>
      <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
    </v-data-table>
    <editBusinessRules
      ref="editBusinessRules"
      @parentRefresh="paginationUpdated"
      @parentInitSelectedRow="initSelectedRow"
      id="editBusinessRules"
      @parentScroll="$vuetify.goTo('#editBusinessRules')"
    ></editBusinessRules>
  </v-card>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import Bus from "../../bus";
import zigZag from "../../components/ZigZag.vue";
import * as helper from "../../helpers/global.js";
import createUser from "./CreateUser.vue";
import moment from "moment";
import editBusinessRules from "./EditBusinessRulesManagement.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "BusinessRulesManagement",

  components: {
    VPage,
    zigZag,
    createUser,
    editBusinessRules,
    DataTablePagination
  },

  data: () => ({
    // reports: [],
    loading: false,
    totalRecords: 0,
    filters: {},
    search: "",
    selectedRow: null,
    businessRules:[],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false,
      totalRecords: 0,
      sortBy: "RuleKey",
      page: 1
    },

    rowsPerPageItems: [
      5,
      10,
      30,
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      }
    ],

    headers: [
      {
        text: "ID",
        value: "RuleKey",
        width: "12%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "Description",
        value: "Description",
        // sortable: false,
        width: "25%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },
      {
        text: "Value",
        value: "Value",
        // sortable: false,
        width: "40%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "22%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ]
  }),
  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },
  mounted() {},
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },
  methods: {
    async initialize() {
      this.filters = {};
      this.selectedRow = null;

      this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/BusinessRules/GetPagedBusinessRulesList/",
          {
            postData: {
              pagination: this.pagination,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.businessRules = response.data.BusinessRules;
          this.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
    },
    categoryClass(item) {
      if (item) {
        var categoryClass;
        categoryClass = item
          .split(" ")
          .join("")
          .replace("/", "");
        return categoryClass;
      }
    },
    async openEditBusinessRules(item) {
      let index = this.businessRules.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.businessRules[index].RuleKey;
      }
      // await this.$refs.createUser.close();
      this.$refs.editBusinessRules.openEdit(item);
    },
    initSelectedRow() {
      this.selectedRow = null;
    }
    // async openCreateUserForm()
    // {
    //   await this.$refs.createUser.close();
    //   this.$refs.createUser.open();
    // },
    // formatDate(value){
    //     if(value)
    //       return moment(value).format('YYYY-MM-DD HH:mm:ss UTC Z')
    //     else
    //       return '';
    // },
    // daysRemaining(value){
    //   var a = moment(value);
    //   var b = moment();

    //   return a.diff(b,'days');
    // },
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
table.v-table tbody tr:hover {
  background-color: #eeeeee !important;
}

.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
/deep/.ACCOUNTING {
  background-color: #ecf0f8;
  /* background-color:#d9e1f2; */
}
/deep/.ACCOUNTS {
  background-color: #fdf1ea;
  /* background-color:#fce4d6; */
}
/deep/.FINANCIAL {
  background-color: #f6f6f6;
  /* background-color:#ededed; */
}
/deep/.HARDALARMS {
  background-color: #fff8e5;
  /* background-color:#fff2cc; */
}
/deep/.OPERATIONAL {
  background-color: #eef5fb;
  /* background-color:#ddebf7; */
}
/deep/.PROVISIONING {
  background-color: #f0f7ec;
  /* background-color:#e2efda; */
}
/deep/.REGULATORY {
  background-color: #ffe3e6;
  /* background-color:#ffc7ce; */
}
/deep/.SALESANDMARKETING {
  background-color: #fff5cd;
  /*  background-color:#ffeb9c; */
}
/deep/.SOFTALARMS {
  background-color: #d9e2f3;
  /* background-color:#B4C6E7; */
}
/deep/.TICKETTROUBLE {
  background-color: #fbe5d6;
  /* background-color:#F8CBAD; */
}
/deep/.USERDEFINED {
  background-color: #ededed;
  /* background-color:#dbdbdb; */
}
</style>
